// extracted by mini-css-extract-plugin
export default {"welcomeHeader":"style_welcomeHeader__VUSbD","welcomeHeaderLogo":"style_welcomeHeaderLogo__Togoi","profileWrapper":"style_profileWrapper__w6wmm"};